@if (data) {
  <div>
    <div class="header">
      <h2>Hospital: {{data.HospitalName}}</h2>
    </div>
    <div class="info-sec">
      <div class="info-item">
        Hospital Code: {{data.HospitalCode}}
      </div>
      <div class="info-item">
        Owner: {{data.OwnerReportDesc}}
      </div>
      <div class="info-item">
        Site Coordinator: {{data.SiteCoordinatorName}}
      </div>
      <div class="info-item">
        Site Coordinator Email: {{data.SiteCoordinatorEmail}}
      </div>
      <div class="info-item">
        Magnet: {{data.MagnetReportDesc}}
      </div>
      <div class="info-item">
        Census Division: {{data.CensusDivisionReportDesc}}
      </div>
      <div class="info-item">
        Case Mix: {{data.CaseMixIndexCategoryReportDesc}}
      </div>
      <div class="info-item">
        Bed Size Report Description: {{data.BedSizeReportDesc}}
      </div>
      <div class="info-item">
        Version Name: {{data.VersionName}}
      </div>
    </div>
  </div>
}
